import styled from 'styled-components';

export const ContainerStyled = styled.div<{
    show: boolean;
}>`
    background: #343A40;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    min-width: 344px;
    gap: 60px;
    width: max-content;
    box-shadow: 0px 8px 24px rgba(51, 55, 60, 0.16);
    border-radius: 4px;
    margin: 60px auto 0;

    ${({show}) => show ? `
        visibility: visible;
        pointer-events: auto;
    `
    :
    `
        visibility: hidden;
        pointer-events: none;
    ` 
    }
`

export const BodyStyled = styled.p`
    margin-bottom: 0;
    line-height: 18px;
    font-size: 14px;
    color: #FFF;
    font-weight: 325;
`

export const IconStyled = styled.img `
    cursor: pointer;
`;